export default function () {
    return {
        INFO: 'INFO',
        OVERALL_OVERVIEW: 'OVERALL_OVERVIEW',
        PERSONAL_DEVELOPMENT: 'PERSONAL_DEVELOPMENT',
        RESULTS_AND_GOALS: 'RESULTS_AND_GOALS',
        TRAINING_NEED: 'TRAINING_NEED',
        SUMMARY: 'SUMMARY',
        FEEDBACK: 'FEEDBACK'
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/review/step/index.js